/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Scope_BodyInputs */

const en_svc_n8n_scope_body = /** @type {(inputs: Svc_N8n_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n is a workflow automation platform that can run on your own server, connects to hundreds of services and has AI steps built in. It suits processes with clear steps. When a process needs heavier logic, we build that part in code and keep n8n as the glue.`)
};

const lv_svc_n8n_scope_body = /** @type {(inputs: Svc_N8n_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n ir darba plūsmu automatizācijas platforma, ko var darbināt uz sava servera, kas savienojas ar simtiem pakalpojumu un kurā ir iebūvēti AI soļi. Tā der procesiem ar skaidriem soļiem. Ja procesam vajag sarežģītāku loģiku, šo daļu veidojam kodā, un n8n paliek kā savienojošais slānis.`)
};

/**
* | output |
* | --- |
* | "n8n is a workflow automation platform that can run on your own server, connects to hundreds of services and has AI steps built in. It suits processes with cl..." |
*
* @param {Svc_N8n_Scope_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_scope_body = /** @type {((inputs?: Svc_N8n_Scope_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Scope_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_scope_body(inputs)
	return en_svc_n8n_scope_body(inputs)
});